import React from 'react'
import Layout from './index'
import messages from '../data/messages/fr'

export default props => <Layout {...props} i18nMessages={messages}></Layout>
